import { Box, Grid, Skeleton } from '@mui/material';
import _ from 'lodash';

interface ScholarshipStickyCardSkeletonProps {
  hideImage?: boolean;
  hideScholarshipType?: boolean;
  hideWorth?: boolean;
  hideLink?: boolean;
  hideDownloadableFile?: boolean;
}
export const ScholarshipStickyCardSkeleton: React.FC<ScholarshipStickyCardSkeletonProps> = ({
  hideImage,
  hideScholarshipType,
  hideWorth,
  hideLink,
  hideDownloadableFile,
}) => {
  return (
    <Box>
      {!hideImage && <Skeleton height="12.5rem" variant="rectangular" width="100%" />}
      <Box sx={{ py: 3, px: { xs: 0, lg: 3 } }}>
        {!hideWorth && <Skeleton variant="rectangular" sx={{ mb: 3 }} height="1.5rem" width="90%" />}
        <Grid container alignItems="center" spacing={3}>
          <Grid item xs>
            <Skeleton variant="rectangular" height="3rem" />
          </Grid>
          <Grid item>
            <Skeleton height="3rem" width="3rem" variant="circular" />
          </Grid>
        </Grid>
        <Box sx={{ my: 0.25 }}>
          <Skeleton variant="text" width="10rem" />
        </Box>
        <Skeleton variant="rectangular" height="3rem" />
        {!hideScholarshipType && (
          <Box sx={{ mt: 3 }}>
            <Skeleton width="7.5rem" variant="text" />
            <Box sx={{ mt: 0.5 }}>
              <Grid container spacing={0.5}>
                {_.times(2, _.stubArray).map((_item, index) => (
                  <Grid item xs={12} key={index}>
                    <Skeleton width="100%" height="0.875rem" />
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Box>
        )}
      </Box>
      {(!hideDownloadableFile || !hideLink) && (
        <Box sx={{ py: 3, px: { xs: 0, lg: 3 }, borderTop: (theme) => `1px solid ${theme.palette.grey[200]}` }}>
          <Grid container alignItems="center" justifyContent="center" spacing={3}>
            {!hideDownloadableFile && (
              <Grid item xs>
                <Skeleton variant="rectangular" height="3rem" />
              </Grid>
            )}
            {!hideLink && (
              <Grid item>
                <Skeleton width="7.5rem" height="1.25rem" />
              </Grid>
            )}
          </Grid>
        </Box>
      )}
    </Box>
  );
};
